declare function require(moduleName: string): any;

const { name, version } = require('../../../package.json');

export const envbase = {
  env: 'base',
  app: name,
  version: version,
  sentryDsn: null as any // 'https://c0bb27336dfc117efc5991ab6b83d80e@o1261118.ingest.us.sentry.io/4509312641597440',
};
